import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
  namespaced: true,
  state: {
    objs: []
  },
  getters: {
    ...functions.createDefaultGetters(['work', 'bankAccount']),
    getByWork: state => work => {
      return state.objs.filter(ub => ub.work === work);
    },
    getByBankAccount: state => bankAccount => {
      return state.objs.filter(ub => ub.bankAccount === bankAccount);
    }
  },
  mutations: {
    ...functions.createDefaultMutations(['user', 'bankAccount']),
  },
  actions: {
    ...functions.createDefaultActionsWithStore(['user', 'bankAccount'])
  },
}